import type { IFailedShoppingItem } from '@inter-ikea-kompis/types';

import AbstractException from '../AbstractException';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum';

/**
 * Custom exception.
 */
export default class ShoppingCartException extends AbstractException {
	public readonly exceptionType = ExceptionTypeEnum.shoppingCart;
	public readonly name = 'ShoppingCartException';
	public readonly failedShoppingItems = Array<IFailedShoppingItem>();
	public readonly errorList = Array<{ code: string; message: string; items: string[] }>();

	/**
	 * Class constructor.
	 *
	 * @param failedShoppingItems Failed shopping items from the server. Probably from the NifApi when add to cart request fails.
	 * @param errorList Expected errors from the Cart API.
	 */
	constructor(
		failedShoppingItems: IFailedShoppingItem[],
		errorList: Array<{ code: string; message: string; items: string[] }>
	) {
		super(
			`Error when trying to add items to cart. ${
				failedShoppingItems ? 'Article errors: ' + JSON.stringify(failedShoppingItems) : ''
			}`
		);

		this.failedShoppingItems = failedShoppingItems;
		this.errorList = errorList;
	}
}
